import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  z-index: 2;\n  top: 0;\n  left: 0;\n  opacity: 0.1;\n  height: 100%;\n  background-color: ", ";\n  position: fixed;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 30px;\n  height: 30px;\n  border: none;\n  border-radius: 100px;\n  background: ", ";\n  cursor: pointer;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 22px;\n  line-height: 30px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin: 30px 30px 0px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: initial;\n  min-width: 315px;\n  margin: 20px 30px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState, useRef, useEffect } from 'react';
import { AcornsIcon } from '@acorns/icons';
import { useMediaQuery } from 'react-responsive';
import { SelectionList } from '../SelectionList';
import styled from '../utils/styling/styled-components';
import { Heading } from '../Typography';
import { ActionButton } from '../ActionButton';
import { theme } from '../theme';
import { DropdownMenu } from './DropdownMenu';
import { ResponsiveMenu } from './ResponsiveMenu';
var StyledSelectionList = styled(SelectionList)(_templateObject());
var HeaderContainer = styled.div(_templateObject2());
var Header = styled(Heading)(_templateObject3());
var CloseButton = styled.button(_templateObject4(), function (props) {
  return props.theme.colors.ivory;
});
var Container = styled.div(_templateObject5());
var Overlay = styled.div(_templateObject6(), function (props) {
  return props.theme.colors.slate;
});
export var SelectionListDropdown = function SelectionListDropdown(_ref) {
  var options = _ref.options,
      selectedOption = _ref.selectedOption,
      handleSelectOption = _ref.handleSelectOption,
      title = _ref.title,
      actionButtonIcon = _ref.actionButtonIcon,
      hasOverlay = _ref.hasOverlay,
      className = _ref.className;
  var isResponsive = useMediaQuery({
    query: "(max-width: ".concat(theme.breakpoints.md, "px)")
  });
  var Menu = isResponsive ? ResponsiveMenu : DropdownMenu;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var clickOutsideRef = useRef(null);

  var toggleDropdown = function toggleDropdown() {
    setIsOpen(!isOpen);
  };

  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (clickOutsideRef.current && !clickOutsideRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [clickOutsideRef]);

  var handleOptionSelect = function handleOptionSelect(option) {
    handleSelectOption(option);
    setIsOpen(false);
  };

  return /*#__PURE__*/React.createElement(Container, {
    className: className
  }, /*#__PURE__*/React.createElement(ActionButton, {
    icon: /*#__PURE__*/React.createElement(AcornsIcon, {
      icon: actionButtonIcon !== null && actionButtonIcon !== void 0 ? actionButtonIcon : AcornsIcon.Icon.AcornsLogo,
      height: 24,
      width: 24
    }),
    onPress: toggleDropdown,
    actionText: "toggleDropdown"
  }), isOpen && /*#__PURE__*/React.createElement(React.Fragment, null, hasOverlay && !isResponsive && /*#__PURE__*/React.createElement(Overlay, null), /*#__PURE__*/React.createElement("div", {
    ref: clickOutsideRef
  }, /*#__PURE__*/React.createElement(Menu, {
    onClick: toggleDropdown,
    hasArrow: false
  }, /*#__PURE__*/React.createElement(HeaderContainer, null, /*#__PURE__*/React.createElement(Header, null, title), /*#__PURE__*/React.createElement(CloseButton, {
    onClick: toggleDropdown
  }, /*#__PURE__*/React.createElement(AcornsIcon, {
    icon: AcornsIcon.Icon.CloseXIcon,
    height: 12,
    width: 12
  }))), /*#__PURE__*/React.createElement(StyledSelectionList, {
    options: options,
    value: selectedOption,
    onSelect: handleOptionSelect
  })))));
};